import { GhostMark } from './GhostMark'
import './black.css'

// The Vouchr Black plan badge: a gold-foil pill with the brand ghost. Shown in
// the sidebar and on the billing screen for recruiters who've been assigned the
// comp tier. `sm` is the compact sidebar size.
export function BlackBadge({ sm }: { sm?: boolean }) {
  return (
    <span className={`black-badge${sm ? ' black-badge--sm' : ''}`}>
      <GhostMark size={sm ? 14 : 17} tint="founding" />
      <span className="gold-foil">Vouchr Black</span>
    </span>
  )
}
